import { Card, CardContent, Chip, Grid, Tooltip, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmDialog from "common/components/ConfirmDialog";
import React, { useState } from "react";
import tripService from "services/tripService";

const TripHeaderView = ({ trip }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const deleteParent = () => {
    tripService.deleteTripParent(trip.id).then(() => {
      setModalOpen(false);
      window.location.reload();
    });
  };

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardContent>
              <Typography gutterBottom sx={{ color: "text.secondary", fontSize: 14 }}>
                Client Trip Info
              </Typography>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <b>Client: </b>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.clientName || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Control Number: </b>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.controlNumber || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Short Key: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.shortKey || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Trip Type: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.tripType?.name || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Hub: </b>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.hub.name || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Time Zone</b>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.hubTimeZone?.label}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Call Date and Time: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.callDateTime.format("MM/DD/YYYY HH:mm") || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Requestor Name: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.requesterName || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Requestor Phone: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.requesterPhone || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Train Number: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.trainNumber || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Lead Locomotive: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.leadLocomotive || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Cancelled: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.cancelled ? "Yes" : "No"} {trip?.cancelledReason ? `- ${trip?.cancelledReason}` : ""}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Comments: </b>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.comments || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>On-Time Performance: </b>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.onTimePerformanceStatus || "--"}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Card>
            <CardContent>
              <Typography gutterBottom sx={{ color: "text.secondary", fontSize: 14 }}>
                Pickup / Dropoff Details
              </Typography>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <b>Pick Up Point: </b>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.pickupLocation ? (
                    <Link to={`/points/${trip?.pickupLocation.id}`}>{trip?.pickupLocation?.name}</Link>
                  ) : (
                    "--"
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Pickup Date and Time: </b>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.pickupDateTimeLocal?.format("MM/DD/YYYY HH:mm") || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>ASAP: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.asap ? "True" : "False"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Drive Time Mins: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.driveTime || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Distance (Hub to Pickup): </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.distance || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Drop Off Point: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.dropoffLocation ? (
                    <Link to={`/points/${trip?.dropoffLocation.id}`}>{trip?.dropoffLocation?.name}</Link>
                  ) : (
                    "--"
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Estimated Assist Hours: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.estAssistHours || "--"}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Card sx={{ mt: 1 }}>
            <CardContent>
              <Typography gutterBottom sx={{ color: "text.secondary", fontSize: 14 }}>
                RCX Internal Details
              </Typography>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <b>Trip Status: </b>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.isClosed ? "Closed" : "Open"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Closed By: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.tripReview?.closedBy || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Approved By: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.tripReview?.approvedBy || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Approved Date: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.tripReview?.approvedDate || "--"}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <b>Related Trips: </b>{" "}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {trip?.relatedTrips &&
                    trip?.relatedTrips.map((m, i) => (
                      <React.Fragment key={i}>
                        <Chip
                          key={i}
                          sx={{ mr: m.isParent ? 0 : 2, mb: 1 }}
                          label={`${m.controlNumber} ${m.isParent ? "(parent)" : ""}`}
                          component={Link}
                          to={`/trips/${m.id}`}
                          clickable
                        />
                        {m.isParent && (
                          <>
                            <Tooltip title="Delete Parent" placement="top">
                              <DeleteIcon onClick={() => setModalOpen(true)}></DeleteIcon>
                            </Tooltip>
                          </>
                        )}
                      </React.Fragment>
                    ))}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <ConfirmDialog
        open={modalOpen}
        setOpen={setModalOpen}
        title="Delete Parent Relationship"
        subTitle="Are you sure you want to delete this trip's parent relationship?"
        onAccept={deleteParent}
      />
    </>
  );
};
export default TripHeaderView;
